import React from "react";
import { useStyles } from "./styles";
import { text } from "./text";
import { links } from "./constants";

export function CareerSection() {
  const classes = useStyles();

  return (
    <div className={classes.column}>
      <h1 className={classes.title}>{text.header}</h1>
      <h3 className={classes.description}>
        {text.description}{" "}
        <a href={links.job} target="_blank" rel="noopener noreferrer">
          {text.linkedIn}
        </a>
        {text.exclamation}
      </h3>
      {/* <CareerCard /> */}
    </div>
  );
}
